import { useCallback, useEffect, useRef } from 'react';
import { collectMetadata } from 'shared/services/featurebase/metadata-collector';

import { useFeaturebaseScript } from './use-featurebase-script';

const defaultBoardName = '🐞 Bugs';

export const useFeaturebaseWidget = (token?: string) => {
  const { isReady, isError } = useFeaturebaseScript();

  const lastTokenRef = useRef<string | null>(null);

  // Pre-initialize widget as soon as token + SDK are available
  useEffect(() => {
    if (!isReady || isError || !token) {
      return;
    }

    if (lastTokenRef.current === token) {
      return;
    }

    if (window.Featurebase) {
      const metadata = collectMetadata();

      window.Featurebase('initialize_feedback_widget', {
        organization: 'griply',
        theme: 'light',
        defaultBoard: defaultBoardName,
        locale: 'en',
        metadata,
        featurebaseJwt: token,
      });

      lastTokenRef.current = token;
    }
  }, [isReady, isError, token]);

  const openWidget = useCallback(() => {
    window.postMessage(
      {
        target: 'FeaturebaseWidget',
        data: { action: 'openFeedbackWidget', setBoard: defaultBoardName },
      },
      '*',
    );
  }, []);

  return {
    openWidget,
    isReady,
  };
};
